/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_Raffled_AddInputs */



/**
* | output |
* | --- |
* | "Add to report" |
*
* @param {Promos_Raffled_AddInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_raffled_add = /** @type {((inputs?: Promos_Raffled_AddInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_Raffled_AddInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter au rapport")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir al informe")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar ao relatório")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi al rapporto")
	return /** @type {LocalizedString} */ ("Add to report")
});